import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import classNames from 'classnames';
import { ga } from 'helpers/multitrack';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
export var FaqUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(FaqUnwrapped, _Component);

  function FaqUnwrapped(props) {
    var _this;

    _classCallCheck(this, FaqUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FaqUnwrapped).call(this, props));
    _this.state = {};
    return _this;
  }

  _createClass(FaqUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      ga('FAQ Module', 'Viewed FAQ module', '', 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(index, question) {
      this.setState(_defineProperty({}, "q".concat(index), !this.state["q".concat(index)]));

      if (!this.state["q".concat(index)]) {
        ga('FAQ Module', 'Expanded question', question, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          faq = _this$props.faq,
          backgroundColor = _this$props.backgroundColor;
      return React.createElement("div", {
        className: "bg--".concat(backgroundColor || 'white')
      }, React.createElement("div", {
        className: "pricing-faq"
      }, React.createElement("h2", {
        className: "gamma"
      }, title), React.createElement("ul", null, faq.map(function (q, i) {
        return React.createElement("li", {
          // eslint-disable-next-line react/no-array-index-key
          key: i,
          onClick: function onClick() {
            return _this2.handleClick(i, q.question);
          }
        }, React.createElement("h3", null, React.createElement(Isvg, {
          className: classNames('pricing-faq__arrow', {
            selected: _this2.state["q".concat(i)] || false
          }),
          uniquifyIDs: false,
          src: require('../../../../../static/img/arrow.svg')
        }), q.question), !!_this2.state["q".concat(i)] && React.createElement("p", null, q.answer));
      }))));
    }
  }]);

  return FaqUnwrapped;
}(Component);
FaqUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light']),
  faq: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.string,
    question: PropTypes.string,
    type: PropTypes.string
  })),
  title: PropTypes.string
};

FaqUnwrapped.propMapper = function (state, moduleDef) {
  return {
    title: moduleDef.title,
    faq: moduleDef.questions
  };
};

export var Faq = trackDwell(FaqUnwrapped);